import AlcoholSVG from "@design-system/ui-icons/vanilla/Alcohol"
import { createIcon } from "../createIcon"

export const AlcoholIcon = createIcon(AlcoholSVG)
